// The Log in <-> Create an account switch (2026-10-29): the link to the other
// page carries the three params both pages read - where to go after (redirect),
// the plan, and the source - and nothing else (never a Clever / ClassLink return
// or error param).
const KEPT = ['redirect', 'plan', 'source'];

export function authSwitchLink(path, search) {
  const from = new URLSearchParams(search || '');
  const to = new URLSearchParams();
  KEPT.forEach((key) => {
    const value = from.get(key);
    if (value) to.set(key, value);
  });
  const query = to.toString();
  return query ? `${path}?${query}` : path;
}
